import React, { useEffect, useState } from 'react';
import styles from './OuterCounter.module.css';
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';
import phaseA from "../../../../img/phaseA.svg";
import phaseB from "../../../../img/phaseB.svg";
import phaseC from "../../../../img/phaseC.svg";

const OuterCounter = ({ connector }) => {
    let lang = localStorage.getItem('language') === 'ru';

    const formatTime = (seconds) => {
        if (seconds == null) {
            return "00:00";
        }
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    };

    const formatAmperege = (amperage) => {
        if (!amperage) {
            return "0.0";
        }
        const parseAmpere = (amperage * 1).toFixed(1);
        return parseAmpere;
    };

    const formatPower = (power) => {
        if (!power) {
            return "0.0";
        }
        const parsePower = (power / 100).toFixed(1);
        return parsePower;
    };

    return (
        <div className={styles.parameters}>
            <p className={styles.titleText}>{lang ? "Внешний счетчик" : "Outer counter"}</p>
            <div className={styles.blocks}>
                {/* Colomn 1 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={phaseA} className={styles.paramImage} alt='phase A' />
                        </div>
                        <p className={styles.paramText}>{lang ? "Фаза" : "Phase"}</p>
                    </div>
                    <p className={styles.paramText}>{formatAmperege(connector?.iam)}
                        <span className={styles.unitGray}> A </span>
                        <span className={styles.spacedValue}>
                            {connector?.uam ? connector?.uam : '0.0'} </span>
                        <span className={styles.unitGray}> {lang ? "B" : "V"}</span> </p>
                </div>
                {/* Colomn 2 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={phaseB} className={styles.paramImage} alt='phase B' />
                        </div>
                        <p className={styles.paramText}>{lang ? "Фаза" : "Phase"}</p>
                    </div>
                    <p className={styles.paramText}>{formatAmperege(connector?.ibm)}
                        <span className={styles.unitGray}> A </span>
                        <span className={styles.spacedValue}>
                            {connector?.ubm ? connector?.ubm : '0.0'} </span>
                        <span className={styles.unitGray}> {lang ? "B" : "V"}</span> </p>
                </div>
                {/* Colomn 3 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={phaseC} className={styles.paramImage} alt='phase C' />
                        </div>
                        <p className={styles.paramText}>{lang ? "Фаза" : "Phase"}</p>
                    </div>
                    <p className={styles.paramText}>{formatAmperege(connector?.icm)}
                        <span className={styles.unitGray}> A </span>
                        <span className={styles.spacedValue}>
                            {connector?.ucm ? connector?.ucm : '0.0'} </span>
                        <span className={styles.unitGray}> {lang ? "B" : "V"}</span> </p>
                </div>
            </div>
        </div>
    )
}

export default OuterCounter;